import { generateMedia } from 'styled-media-query'

const dimensions = ['sm', 'smd', 'md', 'lg', 'xl', 'xxl']

const breakpoints = {
   sm: 576,
   smd: 640,
   md: 743,
   lg: 1025,
   xl: 1200,
   xxl: 1400,
}

const mediaObject = dimensions.reduce((acc, cur) => ({ ...acc, [cur]: `${breakpoints[cur]}px` }), {})

const media = generateMedia(mediaObject)

export default media
